import {
  browserName,
  osName,
  osVersion,
  browserVersion,
  mobileModel,
  mobileVendor,
} from "react-device-detect";

import FormField from "../../../components/FormField";
import { useIsMobile } from "../../../hooks/useIsMobile";
import CloseIcon from "../../../components/CloseIcon";

const DebugOptions = ({ close, onFooterSelect }: { close: () => void; onFooterSelect?: (tab: any) => void }) => {
  const isMobile = useIsMobile(768);

  const handleClose = () => {
    if (isMobile && onFooterSelect) {
      onFooterSelect('origins');
    }
    close();
  };

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          position: "absolute",
          right: 10,
          top: 10,
          zIndex: 1013,
        }}
      >
        <CloseIcon onClick={handleClose} />
      </div>
      <div
        style={{
          overflowY: "auto",
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          padding: isMobile ? 10 : 32,
          gap: 30,
        }}
      >
        {/* FILTER OPTIONS */}
        <div>
          <div
            style={{
              fontSize: 22,
              fontWeight: 700,
              color: "#595959",
              paddingBottom: 10,
            }}
          >
            Debug
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 20,
              maxWidth: 400,
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 4,
                paddingLeft: 4,
                color: "#4B4B4B",
              }}
            >
              <div style={{ fontSize: 18, fontWeight: 600 }}>Device</div>

              <div style={{ display: "flex", paddingLeft: 8 }}>
                <FormField label="Vendor">
                  <div>{mobileVendor}</div>
                </FormField>
                <FormField label="Model">
                  <div>{mobileModel}</div>
                </FormField>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 4,
                paddingLeft: 4,
                color: "#4B4B4B",
              }}
            >
              <div style={{ fontSize: 18, fontWeight: 600 }}>
                Operating System
              </div>

              <div style={{ display: "flex", paddingLeft: 8 }}>
                <FormField label="Name">
                  <div>{osName}</div>
                </FormField>
                <FormField label="Version">
                  <div>{osVersion}</div>
                </FormField>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 4,
                paddingLeft: 4,
                color: "#4B4B4B",
              }}
            >
              <div style={{ fontSize: 18, fontWeight: 600 }}>Browser</div>

              <div style={{ display: "flex", paddingLeft: 8 }}>
                <FormField label="Name">
                  <div>{browserName}</div>
                </FormField>
                <FormField label="Version">
                  <div>{browserVersion}</div>
                </FormField>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 4,
                paddingLeft: 4,
                color: "#4B4B4B",
              }}
            >
              <div style={{ fontSize: 18, fontWeight: 600 }}>Screen</div>

              <div style={{ display: "flex", paddingLeft: 8 }}>
                <FormField label="Width">
                  <div>{String(window.outerWidth)}</div>
                </FormField>
                <FormField label="Height">
                  <div>{String(window.outerHeight)}</div>
                </FormField>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DebugOptions;
